import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://magicbolt.ai";
// 1200x630 PNG - the size and format link previews (WhatsApp, LinkedIn,
// Facebook, X) expect. Replace public/og-default.png to change it.
const DEFAULT_IMAGE = `${SITE_URL}/og-default.png`;

export default function SEO({ title, description, path = "/", image = DEFAULT_IMAGE, noindex = false, breadcrumbs }) {
  const url = `${SITE_URL}${path}`;

  // Optional BreadcrumbList JSON-LD - pass e.g.
  // [{ name: "Home", path: "/" }, { name: "Pricing", path: "/pricing" }]
  const breadcrumbJsonLd =
    breadcrumbs && breadcrumbs.length > 0
      ? {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: breadcrumbs.map((b, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: b.name,
            item: `${SITE_URL}${b.path}`,
          })),
        }
      : null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MagicBolt AI" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      {image === DEFAULT_IMAGE && <meta property="og:image:width" content="1200" />}
      {image === DEFAULT_IMAGE && <meta property="og:image:height" content="630" />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {breadcrumbJsonLd && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
      )}
    </Helmet>
  );
}
